export const DEFAULT_COLOR = '#22EDC8';
export const DEFAULT_BAR_COLORS = ['#22EDC8', '#6355ff', '#FF7EDB'];
export const DEFAULT_HEIGHT = 379;
export const DEFAULT_WIDTH: number | string = '100%';
export const DEFAULT_DECIMALS = 0;
